import {getImageUrl, onError, message, errorHandler, logout, loader, routeErrorHandler, beforeAvatarUpload} from '@/libs/helper'
import {isEmpty} from 'lodash'
import constants from '@/libs/constant/constants'
import pageRoute from '@/libs/constant/pageRoutes'
import {getOrganisationsTeam, createOrganisationTeam, getImageUploadURL, uploadImage, createScreenName, getTeamById, updateTeam, getScreenNameDetails} from '@/libs/api/api'
import { Mentionable } from 'vue-mention'
import mentionListMixin from '@/mixins/mentionListMixin'
import 'quill-mention';

export default {
    name: 'TeamForm',
    components: {Mentionable},
    mixins: [mentionListMixin],
    beforeMount() {
        // if edit mode is on
        if (this.$route.name === pageRoute.editTeam) {
            this.isEdit = true
            // set form data
            this.setFormData()
        }
        this.setTeams()
    },
    computed: {
        editor() {
          return this.$refs.myQuillEditor.quill
        }
    },
    data() {
        return {
            publisher: {
                name: '',
                screen_name: '',
                description: '',
                description_html: ''
            },
            formData: {},
            debounce: null,
            isEdit: false,
            isVisible: 'visible',
            showDropdown: false,
            getImageUrl,
            onError,
            teams: [],
            selectedTeam: '',
            file: {},
            uploadImageData:{},
            imagePreview: null,
            imageName: '',
            imageAvatar: null,
            imageBlobData: null,
            skip: 0,
            limit: 30,
            sorted: '',
            validateSlug: function (rule, value, callback) {
                // eslint-disable-next-line
                let regex = /[!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/
                let checkSpaces = /\s/g
                if (isEmpty(value) || (value && value.length > 20)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (regex.test(value)) callback(new Error(window.i18next.t('Invalid screen name')))
                if (checkSpaces.test(value)) callback(new Error(window.i18next.t('Spaces are not allowed')))
                else callback()
            },
            beforeAvatarUpload
        }
    },
    methods: {
        /**
         * to set the teams organisations teams 
         */
        setTeams () {
            getOrganisationsTeam({organisation: this.$route.params.id}).then(response => {
                this.teams = response.items || []
            }).catch(error => {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * upload file 
         * @param {*} file 
         */
        uploadFile:async function (file) {
            this.imageName = file.file.name
            this.file = file
            this.imageBlobData = await this.createBlobObject({}, file.file)
            this.imagePreview = window.URL.createObjectURL(file.file)    
        },
        /*
        * createBlobObject() creates and returns the binary image format to upload
        * */
       createBlobObject(uploadUrl, file){
            return new Promise((resolve) => {
                let reader = new FileReader(file)
                reader.addEventListener("loadend",function (data) {
                    return resolve({imageData: data.target.result, uploadUrl })
                });
                reader.readAsArrayBuffer(file);
            })
        },
        /*
        * uploadImage() uploads the image to the s3 server
        * */
       async uploadImage (file, isEdit){
            try {
                loader(this, true)
                let body = {...this.publisher}
                body.avatar_image = this.avatar_image
                body.is_visible = this.isVisible === 'secret' ? false : true
                body.created_by_organisation = this.$route.params.id
                let description = await this.fetchScreenNamesDetails()
                if (description !== '') body.description_html = description
                if (this.selectedTeam !== '') body.parent_team = this.selectedTeam
                if (isEmpty(file)) {
                    if (isEdit) this.updateTeamForm(body)
                    else this.createTeamForm(body)
                    return
                }
                getImageUploadURL({imageName: this.imageName})
                    .then((uploadUrls)=>{
                        this.uploadImageData = uploadUrls;
                        return this.createBlobObject(uploadUrls, file.file)
                    }).then((image)=>{
                        return uploadImage(image)
                    }).then(() => {
                        body.avatar_image = this.uploadImageData.fileKey
                        if (isEdit) this.updateTeamForm(body)
                        else this.createTeamForm(body)
                    })
            } catch (error) {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            }
        },
        /**
         * save Teams form
         */
        async saveTeamsForm () {
            try {
                let desc = document.getElementById('quill-editor-description').innerText
                this.publisher.description = !isEmpty(desc) ? desc : ''
                let forms = ['teamImage', 'teamProfile']
                let isValid = true
                forms.map(form => {
                    this.$refs[form].validate((valid) => {
                        if(!valid){
                            isValid = false
                            return
                        }
                    })  
                })
                if (isValid) {
                    this.uploadImage(this.file, this.isEdit)
                }
            } catch (error) {
                console.error('error', error)
            }
        },

        /**
         * route to teams
         */
        routeToTeams (team) {
            this.$store.dispatch('setTeam', team)
            this.$router.push({name: 'teams-overview', params: {id: this.$route.params.id, tid: team._id}})
        },

        /**
         * debounce search
         */
        debounceSearch() {
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                if (this.publisher.name) this.createSlug()
            }, 600)
        },
        /**
         * create screen name
         */
        createSlug () {
            if (this.publisher && isEmpty(this.publisher.name)) {
                return
            }
            // body for api
            let body = {
                entity_type: constants.ORGANISATIONS.TEAM,
                name: this.publisher.name
            }
            createScreenName(body).then(response => {
                this.$set(this.publisher, 'screen_name', response.response)
            }).catch((error) => {
                console.error(error)
            })
        },
        /**
         * set form data
         */
        setFormData () {
            this.formData = this.$store.getters.getTeam || {}
            if (isEmpty(this.formData)) {
                getTeamById(this.$route.params.tid).then(response => {
                    this.formData = response || {}
                    this.setFormValue(this.formData)
                }).catch(error => {
                    console.error(error)
                })
            } else {
                this.setFormValue(this.formData)
            }
        },
        /**
         * set the values for to be prefilled
         * @param {*} data 
         */
        setFormValue (data) {
            this.publisher = {
                name: (data && data.name) || '',
                screen_name: (data && data.screen_name) || '',
                description: (data && data.description) || '',
                description_html: (data && data.description_html) || ''
            }
            this.selectedTeam = (this.formData && this.formData.parent_team && this.formData.parent_team._id) || ''
            this.isVisible = !data.is_visible ? 'secret' : 'visible' 
            this.imagePreview = (data && data.imagePreview) || null
            this.imageName = (data && data.imageName) || ''
            this.imageAvatar = (data && data.avatar_image) || null
            this.$nextTick(async() => {
                this.registerHoveCard()
                let ids = await this.getMentionIds()
                if (!isEmpty(ids)) {
                    let list = await this.getMentionCardDetailList(ids)
                    this.cardDetailList = list
                }
            });
        },

        /**
         * update Team form
         */
        updateTeamForm (body) {
            loader(this, true)
            delete body.created_by_organisation
            updateTeam(body, this.$route.params.tid).then(() => {
                message(this, constants.messageType.SUCCESS, 'Team updated successfully' )
                // route to internal teams page
                let formData = {...this.formData, ...this.publisher}
                this.routeToTeams(formData)
                loader(this, false)
            }).catch(error => {
                console.error(error)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                loader(this, false)
            })
        },
        /**
         * create team and redirect if successfull
         * @param {*} body 
         */
        createTeamForm (body) {
            loader(this, true)
            createOrganisationTeam(body).then((response) => {
                loader(this, false)
                message(this, constants.messageType.SUCCESS, 'Team created successfully')
                // route back to teams
                this.routeToTeams(response)
            }).catch(err => {
                message(this, constants.messageType.ERROR, errorHandler(err, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * to select the screen name(manual) on the basis of regex
         */
        getScreenNames (html) {
            let result = []
            // html is not null
            if (html !== null && html !== undefined) {
                // eslint-disable-next-line
                let regex = /@[a-zA-Z0-9]{2}[a-zA-Z0-9-]*/g
                // return screen names matches the regex
                result = html.match(regex)
            }
            return result
        },
        /**
         * to fetch the screenNames from the 
         * backend if any (@screen-name) is present 
         * and validate it if it is a valid screen 
         * name so create mention tag manually
         */
        async fetchScreenNamesDetails () {
            try {
                // get html
                let html = document.getElementById('quill-editor-description').innerHTML
                // to get the screen names which are not selected
                let screenNames = await this.getScreenNames(html)
                let result = ``
                // if screen names are present
                if (!isEmpty(screenNames)) {
                    // to create the body
                    let screen_names = screenNames.map(item => item.replace('@', ' ').trim())
                    // api call
                    let response = await getScreenNameDetails({screen_names})
                    // if screen names exists, add tehm as tag
                    response.map(mention => {
                        html = html.replace(new RegExp(`@${mention.screen_name}`, 'g'), this.createMentionHTML(mention))
                    })
                    // save it to share
                    result = html
                }
                return result
            } catch (error) {
                console.error(error)
            }
        },
        /**
         * to get the html for manually 
         * created mention tags
         * @param {*} mention object
         */
        createMentionHTML (mention) {
            return `<span class="mention" data-denotation-char="@" data-id="${mention.id}" data-value="<a href=&quot;${mention.link}&quot; target=_blank>${mention.screen_name}" data-toggle="popover" data-link="${mention.link}" data-original-title="" title="">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">@</span><a href="${mention.link}" target="_blank">${mention.screen_name}</a></span></span>`
        }
    }
}